import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/format-message';
import { Setting } from '../Setting';
export var ShuffleAnswers = /*#__PURE__*/function (_Component) {
  function ShuffleAnswers() {
    var _this2;
    _classCallCheck(this, ShuffleAnswers);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ShuffleAnswers, [].concat(args));
    _defineProperty(_this2, "toggleShuffleAnswers", function (event, changeCompleteCb) {
      var _this2$props = _this2.props,
        setQuizShuffleAnswers = _this2$props.setQuizShuffleAnswers,
        activeQuizId = _this2$props.activeQuizId;
      var value = event.target.checked;
      setQuizShuffleAnswers(activeQuizId, value, changeCompleteCb);
    });
    return _this2;
  }
  _inherits(ShuffleAnswers, _Component);
  return _createClass(ShuffleAnswers, [{
    key: "render",
    value: function render() {
      var shuffleAnswers = this.props.shuffleAnswers;
      return /*#__PURE__*/React.createElement(Setting, {
        automationData: "sdk-shuffle-answers-toggle",
        isChecked: shuffleAnswers,
        label: t('Shuffle answers'),
        onChange: this.toggleShuffleAnswers
      });
    }
  }]);
}(Component);
_defineProperty(ShuffleAnswers, "propTypes", {
  setQuizShuffleAnswers: PropTypes.func.isRequired,
  shuffleAnswers: PropTypes.bool.isRequired,
  activeQuizId: PropTypes.string.isRequired
});
export default ShuffleAnswers;